// Global cap on simultaneously-animating decorative particles across the whole
// grid — the settled exact card's drifting dust and looping idle burst, and
// the debris a detonation throws. Exact scores are rare (~once per 2
// gameweeks) but two in one gameweek is normal, and two full treatments at
// once is where this bites: earlier-mounting cards get their full request,
// later ones get whatever remains.
const GLOBAL_PARTICLE_BUDGET = 140
let allocated = 0

/** Reserve up to `request` particles, returning how many were actually granted
 * (0 if the global budget is exhausted). Pair every grant with releaseParticles. */
export function allocateParticles(request: number): number {
  const grant = Math.max(0, Math.min(request, GLOBAL_PARTICLE_BUDGET - allocated))
  allocated += grant
  return grant
}

export function releaseParticles(grant: number): void {
  allocated = Math.max(0, allocated - grant)
}
